import { Component, Input, HostListener, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css'],
})
export class GalleryComponent implements OnInit, AfterViewInit {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;
  @ViewChild('carouselWrapper', { static: true }) carouselWrapper!: ElementRef;
  
  isCard: boolean = false;
  isFullWidth: boolean = false;
  isSorted: boolean = false;
  isMobile: boolean = false;

  displayCustom: boolean = false;
  activeIndex: number = 0;

  responsiveOptions: any[] = [
    { breakpoint: '1500px', numVisible: 5 },
    { breakpoint: '1024px', numVisible: 3 },
    { breakpoint: '768px', numVisible: 2 },
    { breakpoint: '560px', numVisible: 1 },
  ];

  ngAfterViewInit() {
    const el = this.carouselWrapper.nativeElement.querySelector('.p-carousel-items-content');
    if (el) {
      el.addEventListener('wheel', (e: WheelEvent) => {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          e.preventDefault();
          el.scrollLeft += e.deltaY;
        }
      }, { passive: false });
    }
  }

  ngOnInit(): void {
    this.updateIsMobile();
    if (this.fileName.includes('testmonials')) {
      this.isSorted = true;
      this.isCard = true;
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.updateIsMobile();
  }

  updateIsMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  openLink(link: string) {
    if (link) window.open(link, '_blank');
  }
}
